// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--fac06";